import { DispatchRecord, ICreateAssetDispatch } from "../../config/types";
import { buildQueryString } from "../../utils/buildQueryString";
import { apiService } from "../api.service";

const createDispatch = async (data: ICreateAssetDispatch)=> {
    return  apiService.apiRequest<Partial<ICreateAssetDispatch>>('post',`asset-distribution-dispatches`,data)
};


const getAllDispatch = async (queryParams?: { page?: number,is_deleted?:boolean})=> {
    const query=buildQueryString(queryParams);
    return  apiService.apiRequest<DispatchRecord[]>('get',`asset-distribution-dispatches${query}`)
};

const getDispatchDetail = async (dispatch_id:string)=> {
    return  apiService.apiRequest<DispatchRecord>('get',`asset-distribution-dispatches/${dispatch_id}`)
};

const deleteDispatch = async (asset_distribution_dispatch_id:string)=> {
    return  apiService.apiRequest<any>('delete',`asset-distribution-dispatches/${asset_distribution_dispatch_id}/cancel`)

};






export const distributionDispatchApi={
    createDispatch,
    getAllDispatch,
    getDispatchDetail,
    deleteDispatch

}